import React from 'react';
import ModerationRuleEditorSection from '../../../sections/AdminDashboard/Moderation/ModerationRuleEditor';

const AdminModerationRuleEditor = () => {
  return <ModerationRuleEditorSection />;
};

export default AdminModerationRuleEditor;

